module.exports = __webpack_public_path__ + "assets/dde45dfeeb102f1fcce3b6424c301529.png";